import { createSelector } from '@reduxjs/toolkit';
import { selectCommissionType } from 'shared/selectors/jsonQuery';
import { ECommissionType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Без комиссии', value: ECommissionType.WithoutDeposit },
  { label: 'Эксклюзивная', value: ECommissionType.Exclusive },
];

export const selectCommissionTypeFilter = createSelector(selectCommissionType, value => ({
  label: 'Комиссия',
  options: OPTIONS,
  value: [value ?? null],
}));
